import styles from "./ChangeHistoryTable.module.scss"

import {
	getFragmentData,
	graphql,
	type FragmentType,
} from "@/souhl_admin/gql/__generated__"
import {
	getJstFullYear,
	getJstTwoDigitDateStr,
	getJstTwoDigitHourStr,
	getJstTwoDigitMinuteStr,
	getJstTwoDigitMonthStr,
} from "@/utils/jst_date"

const changeHistoryFragment = graphql(/* GraphQL */ `
	fragment ChangeHistoryFields on CompanyCommissionRateChangeHistory {
		id
		cancelFeeCommissionRate
		existingCustomerRereservationCommissionRate
		newCustomerRereservationCommissionRate
		createTime
	}
`)

type Props = {
	histories: readonly FragmentType<typeof changeHistoryFragment>[]
}

const formatDateTime = (dateTimeStr: string): string => {
	const date = new Date(dateTimeStr)
	return `${getJstFullYear(date)}/${getJstTwoDigitMonthStr(date)}/${getJstTwoDigitDateStr(date)} ${getJstTwoDigitHourStr(date)}:${getJstTwoDigitMinuteStr(date)}`
}

const ChangeHistoryTable = ({ histories: rawHistories }: Props) => {
	const histories = getFragmentData(changeHistoryFragment, rawHistories)

	if (histories.length === 0) {
		return (
			<div className={styles.empty}>
				<p>変更履歴はありません</p>
			</div>
		)
	}

	return (
		<table className={styles.table}>
			<thead>
				<tr>
					<th className={styles.header_cell}>変更日時</th>
					<th className={styles.header_cell}>キャンセル料回収手数料率</th>
					<th className={styles.header_cell}>再予約手数料率（既存顧客用）</th>
					<th className={styles.header_cell}>再予約手数料率（新規顧客用）</th>
				</tr>
			</thead>
			<tbody>
				{histories.map((history) => (
					<tr key={history.id} className={styles.row}>
						<td className={styles.cell}>
							{formatDateTime(history.createTime)}
						</td>
						<td className={styles.cell}>{history.cancelFeeCommissionRate}%</td>
						<td className={styles.cell}>
							{history.existingCustomerRereservationCommissionRate}%
						</td>
						<td className={styles.cell}>
							{history.newCustomerRereservationCommissionRate}%
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}

export default ChangeHistoryTable
